import React from "react";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { COMPANY_EMAIL, COMPANY_INSTAGRAM, COMPANY_YOUTUBE } from "../../config/constants";
import { Link } from "react-router-dom";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

const More = () => {
  return (
    <div className="more-page">
      <p className="mb-2 bold uppercase grey"></p>

      <div className="grid-card-more">
        <Link to="/" className="card">
          <div className="card-left">
            <div className="icon" style={{ backgroundColor: "#535C91" }}>
              <EmailRoundedIcon />
            </div>
            <p>Write us on E-mail</p>
          </div>
          <div className="card-right">
            <ChevronRightRoundedIcon />
          </div>
        </Link>

        <Link to="/" className="card">
          <div className="card-left">
            <div className="icon" style={{ backgroundColor: "#E1306C" }}>
              <InstagramIcon />
            </div>
            <p>Folllow us on Instagram</p>
          </div>
          <div className="card-right">
            <ChevronRightRoundedIcon />
          </div>
        </Link>

        <Link to="/" className="card">
          <div className="card-left">
            <div className="icon" style={{ backgroundColor: "#FF0000" }}>
              <YouTubeIcon />
            </div>
            <p>See our YouTube Videos</p>
          </div>
          <div className="card-right">
            <ChevronRightRoundedIcon />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default More;
